var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "klienticta client-action-button",
    "class": _vm.classCst,
    attrs: {
      "type": "button",
      "aria-label": "Otvoriť hypotéky klienta",
      "title": "Otvoriť hypotéky"
    },
    on: {
      "click": _vm.openMortgagePicker
    }
  }, [_c('span', {
    staticClass: "client-action-icon"
  }, [_c('app-icon', {
    attrs: {
      "name": "briefcase",
      "size": 22
    }
  })], 1), _c('span', [_vm._v("Hypotéky")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }